import { useNavigate } from "react-router-dom";

export default function HeaderSwitcher({isMobile}) {
    const navigate = useNavigate();
    const navtoweb = async (e) => {
        e.preventDefault();
        try{
            navigate("/web");
        }
        catch(e){
            console.error(e)
        }

    }
    const mob = isMobile ? 'block' : 'hidden sm:inline-flex'
    return (
        <div className={mob} style={{
            backgroundColor: 'transparent',
            borderWidth: '2px',
            borderColor: 'rgba(114, 113, 113, 1)',
            borderRadius: ' 0.5rem',
            padding: '0.325rem',
            columnGap: '0.125rem'

        }} role="group" >

            <div onClick={navtoweb} className="web-link" style={{
                borderLeftWidth: "1px",
                borderColor: 'transparent',
                borderRadius: '.25rem',
                minWidth: "85px",
                textAlign: 'center',
                cursor: 'pointer'
            }} type="button">
                Web 3D
            </div>
        </div>
    );

}
